import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [token, setToken] = useState(localStorage.getItem("pb_token"));
  const [streamerMode, setStreamerModeState] = useState(localStorage.getItem("pb_streamer") === "1");

  const setStreamerMode = (v) => {
    localStorage.setItem("pb_streamer", v ? "1" : "0");
    setStreamerModeState(v);
  };

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    if (token) {
      refresh();
    } else {
      setUser(false);
    }
  }, [token, refresh]);

  const login = (tok, u) => {
    localStorage.setItem("pb_token", tok);
    setToken(tok);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("pb_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refresh, streamerMode, setStreamerMode }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
